import { Platform, SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { Duration } from '@fullstory/proto/google/protobuf';

export const NEW_SEGMENT_QUERY_PARAM = 'create';

export const EMPTY_SEGMENT_DEFINITION: SegmentDefinition = {
  userProperties: [],
  excludeUserProperties: [],
  behaviors: [],
  excludeBehaviors: [],
  constraints: {
    inOrder: false,
    inSameSession: false,
    platform: Platform.PLATFORM_INVALID,
    timeRange: null,
    completeSessions: false,
    withinTime: Duration.zero,
    eventThresholds: [],
  },
  excludeConstraints: null,
};
